class BaseStorage {
    /**
     * @param {string} prefix 要存储时变量前缀
     * @param {string} type 存储类型是 cookie|localStorage|sessionStorage
     */
    constructor(type, prefix) {
        this.prefix = prefix || process.env.VUE_APP_STORAGE_PREFIX;
    }

    setItem(name, payload) {}

    getItem(name, payload) {}

    removeItem(name, payload) {}
}

export default BaseStorage;
